import type { ProductItem } from './TileListitem.ts';
import { isProductItem } from './TileListitem.ts';
import type { TileListPageLayout } from './TileListPage.ts';

export function replaceProduct(page: TileListPageLayout, replacement: ProductItem): TileListPageLayout {
    const index = page.tileListItems.findIndex(
        (item) => isProductItem(item) && item.localListPosition === replacement.localListPosition,
    );
    if (index === -1) return page;

    const tileListItems = [...page.tileListItems];
    tileListItems[index] = replacement;
    return { ...page, tileListItems };
}
